import {
  AdaptedMap,
  Dependencies,
  Items,
  ById,
  ByPath,
} from 'shared/api/common/schemas/templates/adaptedMap'
import { Map } from 'shared/api/common/schemas/templates/map'
import { ModelsKeys, FilterSection } from 'shared/api/common/schemas/templates/models'

import { getNestedDependencies } from './getNestedDependencies'

export default function (map: Map): AdaptedMap {
  const items = Object.keys(map.models)
    .filter((modelId) => FilterSection !== modelId)
    .reduce((res, modelId) => {
      const model = map.models[modelId as ModelsKeys]
      return res.concat(model.map((item) => ({ ...item, model_id: modelId })))
    }, [] as Items)

  const byId = items.reduce((res, item) => {
    if ('id' in item) {
      res[item.id] = item
    }
    return res
  }, {} as ById)

  const corruptedItems = items.filter((item) => 'is_corrupted' in item && item.is_corrupted)

  const hasCorrupted = corruptedItems.length > 0

  const { dependencies: groupedDependencies } = map

  const sequencesDependencies = map.models.sequences.reduce((res, sequence) => {
    if (res[sequence.id] && sequence.messages) {
      res[sequence.id] = sequence.messages
    }
    return res
  }, {} as Dependencies)
  const directDependencies = {
    ...groupedDependencies.sequence_messages,
    ...groupedDependencies.growth_tools,
    ...groupedDependencies.keywords,
    ...groupedDependencies.intents,
    ...groupedDependencies.flows,
    ...groupedDependencies.generals,
    ...groupedDependencies.triggers,
    ...groupedDependencies.external_triggers,
    ...sequencesDependencies,
  }

  const dependencies: Dependencies = {}
  for (const item of items) {
    // Additional filter is used to exclude current entity from its on dependency list.
    // It fixes cases when you can't uncheck entities that are part of dependency loop.
    dependencies[item.id] = getNestedDependencies(directDependencies, item.id)
  }

  const byPath = map.models.flows.reduce((res, cur) => {
    const { folder_path, id } = cur

    if (folder_path) {
      res[folder_path] ? res[folder_path].push(cur.id) : (res[folder_path] = [id])
    }

    return res
  }, {} as ByPath)

  return {
    ...map,
    items,
    byId,
    corruptedItems,
    hasCorrupted,
    groupedDependencies,
    directDependencies,
    dependencies,
    byPath,
  }
}
